import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBooking } from "@/context/BookingContext";

export default function FinalCTA() {
  const { open, openWith } = useBooking();
  return (
    <section
      data-testid="final-cta-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#0B1F3A] text-white px-8 py-16 md:px-16 md:py-24">
          <div
            className="absolute inset-0 opacity-[0.10] pointer-events-none"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
              backgroundSize: "56px 56px",
              maskImage:
                "radial-gradient(ellipse at top right, black 0%, transparent 70%)",
              WebkitMaskImage:
                "radial-gradient(ellipse at top right, black 0%, transparent 70%)",
            }}
          />
          <div
            className="absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(closest-side, rgba(59,130,246,0.35), transparent)",
            }}
          />

          <div className="relative max-w-3xl">
            <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#3B82F6]">
              Get started
            </div>
            <h2 className="mt-4 font-display font-extrabold text-5xl md:text-6xl tracking-[-0.03em] leading-[0.95]">
              Book smarter.
              <br />
              <span className="text-white/55">Ship with confidence.</span>
            </h2>
            <p className="mt-6 text-lg text-white/70 max-w-2xl">
              Coordinate every freight booking from Turkey while managing the
              entire shipment inside one connected Workspace.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Button
                data-testid="final-cta-book"
                onClick={open}
                size="lg"
                className="group rounded-full bg-[#3B82F6] hover:bg-[#2563EB] text-white px-7 h-12 text-base font-semibold shadow-[0_20px_40px_-15px_rgba(59,130,246,0.7)] hover:-translate-y-0.5 transition-all"
              >
                Book Your Shipment
                <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
              <Button
                data-testid="final-cta-workspace"
                onClick={() => openWith("workspace")}
                size="lg"
                variant="outline"
                className="rounded-full bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white px-7 h-12 text-base font-semibold"
              >
                Create Your Free Workspace
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
